import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { useLanguage } from '../hooks/useLanguage';
import { useScrollReveal } from '../hooks/useScrollReveal';
import { Link } from 'react-router-dom';
export function OtherServicesPage() {
  const {
    t,
    setLocale,
    direction,
    locale
  } = useLanguage();
  const location = useLocation();
  const {
    ref: heroRef,
    isVisible: heroVisible
  } = useScrollReveal();
  const {
    ref: servicesRef,
    isVisible: servicesVisible
  } = useScrollReveal();
  const {
    ref: moreServicesRef,
    isVisible: moreServicesVisible
  } = useScrollReveal();
  const {
    ref: ctaRef,
    isVisible: ctaVisible
  } = useScrollReveal();
  useEffect(() => {
    if (location.pathname.startsWith('/ar')) {
      setLocale('ar');
    } else {
      setLocale('en');
    }
    window.scrollTo(0, 0);
  }, [location.pathname, setLocale]);
  const serviceItems = [{
    title: t('otherServicesPage.services.aftOct.title'),
    description: t('otherServicesPage.services.aftOct.description'),
    isLast: false
  }, {
    title: t('otherServicesPage.services.bnpl.title'),
    description: t('otherServicesPage.services.bnpl.description'),
    isLast: false
  }, {
    title: t('otherServicesPage.services.cardlessAtm.title'),
    description: t('otherServicesPage.services.cardlessAtm.description'),
    isLast: false
  }, {
    label: t('otherServicesPage.services.googlePay.whatsNext'),
    title: t('otherServicesPage.services.googlePay.title'),
    description: t('otherServicesPage.services.googlePay.description'),
    isLast: true
  }];
  return <div className="min-h-screen w-full bg-white text-slate-900" dir={direction} data-id="element-953">
      <Header variant="dark" data-id="element-954" />

      <main data-id="element-955">
        {/* White header background spacer */}
        <div className="bg-white h-20" data-id="element-956" />

        {/* 1. Hero Banner - compact, same size as StatsSection */}
        <section className="gradient-dark-horizontal py-16 md:py-20 relative overflow-hidden" ref={heroRef} aria-label="Beyond The Core Hero" data-id="element-957">
          {/* Top-left decorative SVG */}
          <img src="https://cdn.magicpatterns.com/uploads/oSPxnKHLzspYqMxuH2SAJd/inner-top-left.svg" alt="" role="presentation" aria-hidden="true" className="absolute top-0 left-0 w-[200px] md:w-[300px] h-auto pointer-events-none opacity-20" data-id="element-958" />

          <div className="container mx-auto px-6 md:px-12" data-id="element-959">
            <h1 className={`text-white font-bold leading-[1.1] mb-4 uppercase text-[32px] md:text-[44px] lg:text-[50px] reveal-hidden ${heroVisible ? 'animate-fade-up' : ''}`} data-id="element-960">
              {t('otherServicesPage.hero.title')}
            </h1>
            <p className={`text-white/80 text-base md:text-lg whitespace-pre-line leading-relaxed reveal-hidden ${heroVisible ? 'animate-fade-up delay-200' : ''}`} data-id="element-961">
              {t('otherServicesPage.hero.subtitle')}
            </p>
          </div>
        </section>

        {/* 2. Service Boxes Section */}
        <section className="py-20 md:py-32 bg-white" ref={servicesRef} aria-label="Other Services List" data-id="element-962">
          <div className="container mx-auto px-6 md:px-12" data-id="element-963">
            <div className="flex flex-col gap-6" data-id="element-964">
              {serviceItems.map((item, index) => <div key={index} className={`relative overflow-hidden pt-8 md:pt-10 ${item.isLast ? 'pb-8 md:pb-10' : 'pb-0'} px-8 md:px-10 reveal-hidden ${servicesVisible ? 'animate-fade-up' : ''}`} style={{
              border: '1px solid #E6E6E6',
              borderRadius: 0,
              backgroundColor: item.isLast ? '#F5F8F8' : 'white',
              animationDelay: `${index * 100}ms`
            }} data-id="element-965">
                  {/* SVG decoration bottom-right - only on non-last items */}
                  {!item.isLast && <img src="https://cdn.magicpatterns.com/uploads/cReFqSbgbGUsvkVjkEFgvx/other-services.svg" alt="" role="presentation" aria-hidden="true" className="absolute bottom-0 right-0 pointer-events-none h-[60%] md:h-[90%] w-auto block" style={{
                marginBottom: '-7px',
                marginRight: '-1px'
              }} data-id="element-966" />}

                  <div className="relative z-10 max-w-2xl pb-8 md:pb-10" data-id="element-967">
                    {/* "What's Next?" label for last item */}
                    {'label' in item && item.label && <span className="text-[#25B8D6] font-semibold text-sm mb-2 block" data-id="element-968">
                        {item.label}
                      </span>}
                    <h3 className="text-[#061D76] font-bold text-lg md:text-xl mb-3" data-id="element-969">
                      {item.title}
                    </h3>
                    <p className="text-[#061D76]/70 text-sm md:text-base leading-relaxed" data-id="element-970">
                      {item.description}
                    </p>
                  </div>
                </div>)}
            </div>
          </div>
        </section>

        {/* 3. More Services Section */}
        <section className="py-32 md:py-44 text-white relative overflow-hidden gradient-dark" dir={direction} ref={moreServicesRef} aria-label="More Services" data-id="element-971">
          {/* Background Curves */}
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,_var(--tw-gradient-stops))] from-[#1d8bba]/30 via-transparent to-transparent" aria-hidden="true" data-id="element-972"></div>

          {/* Top-right SVG decoration */}
          <img src="https://cdn.magicpatterns.com/uploads/2mANLj8GZ2QSoaHCJvcbje/more-service-top.svg" alt="" role="presentation" aria-hidden="true" className="absolute top-0 right-0 w-[300px] md:w-[300px] h-auto pointer-events-none opacity-10" data-id="element-973" />

          {/* Bottom-left SVG decoration */}
          <img src="https://cdn.magicpatterns.com/uploads/6b9oFepPZ3EmycFXG1ZrBP/4.svg" alt="" role="presentation" aria-hidden="true" className="absolute bottom-0 left-0 w-[1000px] h-auto pointer-events-none" data-id="element-974" />

          <div className="container mx-auto px-6 md:px-12 relative z-10" data-id="element-975">
            <h2 className={`text-white font-bold mb-12 reveal-hidden ${moreServicesVisible ? 'animate-fade-up' : ''}`} style={{
            fontSize: '1.6rem'
          }} data-id="element-976">
              {t('otherServicesPage.moreServices')}
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-0" data-id="element-977">
              {[{
              title: t('services.cardIssuing.title'),
              description: t('services.cardIssuing.description'),
              icon: 'https://cdn.magicpatterns.com/uploads/p9wNgXqTf5s865qgqSB29i/card.svg',
              href: locale === 'ar' ? '/ar/services/card-issuing' : '/services/card-issuing'
            }, {
              title: t('services.atmAcquiring.title'),
              description: t('services.atmAcquiring.description'),
              icon: 'https://cdn.magicpatterns.com/uploads/jegNccbhUz8TByzbmLGE3q/atm.svg',
              href: locale === 'ar' ? '/ar/services/atm-acquiring' : '/services/atm-acquiring'
            }, {
              title: t('services.mobilePayments.title'),
              description: t('services.mobilePayments.description'),
              icon: 'https://cdn.magicpatterns.com/uploads/jXad5oEVGh1pDvZH3TPpsH/mobile.svg',
              href: locale === 'ar' ? '/ar/services/mobile-payments' : '/services/mobile-payments'
            }].map((service, index) => <Link key={index} to={service.href} className={`group py-10 px-6 md:px-8 border border-white/10 hover:bg-[#25B8D6] transition-colors duration-300 cursor-pointer flex flex-col items-center justify-center text-center aspect-square reveal-hidden ${moreServicesVisible ? 'animate-fade-up' : ''}`} style={{
              animationDelay: `${(index + 1) * 100}ms`
            }} data-id="element-978">
                  <img src={service.icon} alt={service.title} className="w-10 h-10 mb-6 opacity-80 group-hover:opacity-100 transition-opacity" data-id="element-979" />
                  <h3 className="text-lg md:text-xl font-bold mb-3" data-id="element-980">
                    {service.title}
                  </h3>
                  <p className="text-white leading-relaxed text-sm" data-id="element-981">
                    {service.description}
                  </p>
                </Link>)}
            </div>
          </div>
        </section>

        {/* 4. Join Our Bold Thinkers CTA */}
        <section className="relative py-24 text-white overflow-hidden" dir={direction} ref={ctaRef} aria-label="Call to Action" data-id="element-982">
          {/* Background Image */}
          <div className="absolute inset-0 bg-cover bg-center" role="presentation" aria-hidden="true" style={{
          backgroundImage: "url('https://cdn.magicpatterns.com/uploads/aNushftuwBdDBhG34PgQWF/Trusted.jpg')"
        }} data-id="element-983"></div>

          <div className="container mx-auto px-6 md:px-12 relative z-10" data-id="element-984">
            <div data-id="element-985">
              <h2 className={`text-4xl md:text-5xl font-bold mb-6 whitespace-pre-line reveal-hidden ${ctaVisible ? 'animate-fade-left' : ''}`} data-id="element-986">
                {t('aboutPage.cta.heading')}
              </h2>
              <p className={`text-white max-w-[950px] text-lg mb-8 leading-relaxed reveal-hidden ${ctaVisible ? 'animate-fade-left delay-200' : ''}`} data-id="element-987">
                {t('aboutPage.cta.description')}
              </p>
              <button className={`btn-primary reveal-hidden ${ctaVisible ? 'animate-fade-up delay-400' : ''}`} data-id="element-988">
                {t('aboutPage.cta.button')}
              </button>
            </div>
          </div>
        </section>
      </main>

      <Footer data-id="element-989" />
    </div>;
}